import React from 'react';
import { connect } from 'react-redux';
import PopupTitle from '../elements/PopupTitle';
import { __ } from 'i18n-for-browser';
import FinishWhite from '../../assets/img/icons/finish_white.svg';

const desktop = document.querySelector('#root').clientWidth >= 1240;

const TitleBar = props => {
  return (
  <div className="titlebar-outer">
    <div className="titlebar">
      <div className="stepcircle">
        <span className="circle-bg">
          {props.gameState.currentRound === 5 ? (
            <img style={{ width: '20px' }} src={FinishWhite} alt="finish-flag" />
          ) : (
            <p>{__('sim_stap')}<br/><span>{props.gameState.currentStep}</span></p>
          )}
        </span>
      </div>
      {(
        props.gameState !== undefined &&
        !(Object.entries(props.gameState.stepPopup).length === 0 && props.gameState.stepPopup.constructor === Object) ?
          <PopupTitle popupId={!desktop ? props.gameState.stepPopup : 'd' + props.gameState.stepPopup.substring(1)}/>
        : null
      )}
    </div>
  </div>
)};

export default connect(state => ({
  gameState: state.gameState,
}))(TitleBar);



// WEBPACK FOOTER //
// ./src/components/elements/TitleBar.js